import {createAction} from 'redux-actions';

export const SET_TARGET_AGE_OPTIONS = 'SET_TARGET_AGE_OPTIONS';
export const GET_TARGET_AGE_OPTIONS = 'GET_TARGET_AGE_OPTIONS';

export const setTargetAgeOptionsAction = createAction(SET_TARGET_AGE_OPTIONS);
export const getTargetAgeOptionsAction = createAction(GET_TARGET_AGE_OPTIONS);
